import type { DomainHierarchyItem } from '@/entities/domain/domain';

export const findDomainInHierarchy = (
  hierarchy: DomainHierarchyItem[],
  domainId: string
): DomainHierarchyItem | null => {
  for (const item of hierarchy) {
    if (item.id === domainId) {
      return item;
    }
    if (item.children && item.children.length > 0) {
      const found = findDomainInHierarchy(item.children, domainId);
      if (found) return found;
    }
  }
  return null;
};
